import { callApiToServer } from "../callApi";

export async function deleteCategory(authtoken, categoryId) {
  console.log(categoryId);
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let body = JSON.stringify({
      "category_id" : categoryId
    });


    let endUrl = "v1/auth/admin/delete-category";
    console.log("endUrl printed here", endUrl);

    let responseData = await callApiToServer(body,header, "DELETE", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
